<section>
  <div class="form-register">
    <form [formGroup]="formRemissionOrderDetail">
      <div class="row p-1 align-items-end">
        <div class="col-lg-2 col-md-6 col-sm-6 col-12">
          <app-custom-input-text [labelText]="'Artículo'" [disabled]="true" [value]="codeNameRemissionArticle">
          </app-custom-input-text>
        </div>
        <div class="custom-container col-lg-2 col-md-3 col-sm-6 col-12">
          <app-custom-input-text [labelText]="'Bodega'" [disabled]="true" [value]="codeNameStore">
          </app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-6 col-12">
          <app-custom-input-decimal formControlName="quantityFinal" [labelText]="'Pedido'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-6 col-12">
          <app-custom-input-decimal formControlName="quantityPending"
            [labelText]="'Pendiente'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-6 col-12">
          <app-custom-input-decimal formControlName="stock" [labelText]="'Existencia'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-6 col-12">
          <app-custom-input-decimal formControlName="quantityReserved"
            [labelText]="'Reserva'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [required]="true" [labelText]="'Cantidad'"
            (onChangeNumber)="changeQuantity($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 col-12 d-flex justify-content-start">
          <div class="d-flex align-items-end gap-1">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>